export const initialCoordonates = {
    address: 'initialCoordonates',
    latitude: 46,
    longitude: 2,
    zoom: 6,
    animated: false,
};
